import { Container, Row, Col, Card } from "react-bootstrap";
import { FaLinkedinIn } from "react-icons/fa";
import "../../styles/MentorShip.css";

const mentors = [
  {
    name: "Shivoo",
    role: "Semiconductor Industry Leader",
    // desc: "Former Principal Engineer at Google with 15+ years empowering women in tech.",
    image: "/assets/mentors/Shivoo.png",
    linkedin: "https://www.linkedin.com/in/shivoo/",
  },
  {
    name: "Nilesh Ranpura",
    role: "Food Industry Entrepreneur",
    // desc: "Staff Engineer specializing in distributed systems and career advancement.",
    image: "/assets/mentors/Nilesh Ranpura.png",
    linkedin: "https://www.linkedin.com/in/nilesh-ranpura-7270a72/",
  },
  {
    name: "Tanvi Rotti",
    role: "Startup Ecosystem Leader",
    // desc: "Helping engineers navigate promotions and leadership transitions.",
    image: "/assets/mentors/Tanvi Rotti.png",
    linkedin: "https://www.linkedin.com/in/tanvi-rotti/",
  },
  {
    name: "Chethan K R",
    role: "Technology and Engineering Leader",
    // desc: "Former Principal Engineer at Google with 15+ years empowering women in tech.",
    image: "/assets/mentors/Chethan K R.png",
    linkedin: "https://www.linkedin.com/in/chethan-k-r-65561020/",
  },
  {
    name: "Drasti Chauhan",
    role: "Startup Program Manager",
    // desc: "Staff Engineer specializing in distributed systems and career advancement.",
    image: "/assets/mentors/Drasti Chauhan.jpg",
    linkedin: "https://www.linkedin.com/in/drasti-chauhan-b60aa0167/",
  },
  {
    name: "Veena SC",
    role: "HR and People Leader",
    // desc: "Full-stack engineer passionate about inclusive engineering cultures.",
    image: "/assets/mentors/Veena Chakravarthi.png",
    linkedin: "https://www.linkedin.com/in/veenasc/",
  },
  {
    name: "Aparajita Banerjee",
    role: "Innovation Program Director",
    // desc: "Helping engineers navigate promotions and leadership transitions.",
    image: "/assets/mentors/Aparajita Banerjee.jpg",
    linkedin: " https://www.linkedin.com/in/aparajita-banerjee-47b5939/",
  },
  {
    name: "Munmun Dey",
    role: "Startup Community Manager",
    // desc: "Full-stack engineer passionate about inclusive engineering cultures.",
    image: "/assets/mentors/Munmun Dey.png",
    linkedin: "https://www.linkedin.com/in/munmun-dey-7029a42a0/",
  },
];

const MentorsSection = () => {
  return (
    <section className="mentors-section bg-black text-white py-5">
      <Container>
        <h2 className="mentors-heading wise-secondary-gradient fw-bold mb-4">
          Meet Our Mentors
        </h2>

        <Row>
          {mentors.map((mentor, index) => (
            <Col md={3} sm={6} key={index} className="mb-4">
              <Card className="mentor-profile-card bg-title h-100 border-0">
                {/* Image */}
                <div className="mentor-img-wrapper">
                  <Card.Img
                    variant="top"
                    src={mentor.image}
                    alt={mentor.name}
                    className="mentor-img"
                  />
                </div>

                {/* Content */}
                <Card.Body className="mentor-card-body">
                  {/* Name row */}
                  <div className="mentor-name-row">
                    <Card.Title className="text-secondary mentor-name mb-0">
                      {mentor.name}
                    </Card.Title>

                    <a
                      href={mentor.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mentor-linkedin-inline"
                      aria-label={`${mentor.name} LinkedIn`}
                    >
                      <FaLinkedinIn />
                    </a>
                  </div>

                  <small className="text-secondary mentor-role">
                    {mentor.role}
                  </small>

                  <Card.Text className="text-secondary mentor-desc mt-2">
                    {mentor.desc}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default MentorsSection;
